"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import React from "react";
import { twMerge } from "tailwind-merge";

import { Button, ButtonVariant } from "ui/core/button";

interface NavigationButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  variant?: ButtonVariant;
  activeMatchLevel?: number;
  disabled?: boolean;
}

const compareIsActive = (
  pathname: string,
  href: string,
  activeMatchLevel: number
) => {
  const currentPathChunks = pathname.split("/");
  const hrefChunks = href.split("/");

  for (let i = 0; i < activeMatchLevel; i++) {
    currentPathChunks.pop();
    hrefChunks.pop();
  }

  return currentPathChunks.join("/") === hrefChunks.join("/");
};

export const NavigationButton = ({
  href,
  variant = "secondary",
  activeMatchLevel = 0,
  children,
  className,
  disabled,
}: NavigationButtonProps) => {
  const pathname = usePathname();
  const isActive = compareIsActive(pathname, href, activeMatchLevel);

  return (
    <Button
      variant={variant}
      isActive={isActive}
      className={twMerge("p-0", className)}
      disabled={disabled}
    >
      {disabled ? (
        <span className="block px-5 py-2">{children}</span>
      ) : (
        <Link className="block px-5 py-2" href={href}>
          {children}
        </Link>
      )}
    </Button>
  );
};
